<template>
  <div class="role-content">
    <el-card shadow="hover" class="left-bar">
      <div class="search">
        <el-input v-model="searchVal" suffix-icon="el-icon-search"></el-input>
        <el-button icon="el-icon-edit" @click="addDialogVisible = true"></el-button>
      </div>
      <div class="list-content">
        <div v-for="item in desList" :key="item.id" class="role-item" :class="getActive(item)">
          <div class="role-label" :title="item.label" @click="getItem(item)">{{ item.name }}</div>
          <div style="margin-left: auto;">
            <el-button size="mini" icon="el-icon-delete" type="text" @click="del(item.id)"> </el-button>
          </div>
        </div>
      </div>
    </el-card>
    <el-card shadow="hover" class="route-content" :key="getKey">
      <div>
        <Tab :data="tabList" @click="tabClick"></Tab>
      </div>
      <router-view :key="getKey"></router-view>

    </el-card>

    <el-dialog :close-on-click-modal="false" title="添加" :visible.sync="addDialogVisible" width="50%" @close="closeAdd">
      <Setting-Form @sendData="sendFormData" />
    </el-dialog>
  </div>
</template>


<script>
import axios from "axios";

import Tab from "../../userConfig/configComp/Tab.vue";
import SettingForm from "../APIConfig/settingForm.vue";
export default {
  name: "SettingAPI",
  components: {
    SettingForm,
    Tab
  },
  data() {
    return {

      list: [],

      privList: [],
      privData: {},
      allList: [],

      searchVal: '',
      btnLoading: false,
      btnDisabled: false,

      tableName: [
        this.$t("message.transform.choices"),
        this.$t("message.transform.selected"),
      ],
      filterType: [],

      dialogVisible: false,
      addDialogVisible: false,

      showTable: false,
      tableData: [],
      showTitle: '',
      addForm: {},
      addFormRoles: {
        name: [
          { required: true, message: this.$t('message.tips.inputName'), trigger: "blur" },
          { min: 3, max: 25, message: this.$t('message.warning.length_101'), trigger: "blur" }
        ],
        // description: [
        //   { required: true, message: this.$t('message.tips.inputDes'), trigger: "blur" },
        //   { min: 5, max: 20, message: this.$t('message.warning.length_102'), trigger: "blur" }
        // ]
      },//添加验证规则
      tabList: [
        { label: "详细信息", id: 1, path: '/info' },
        { label: "使用位置", id: 2, path: '/whereused' },
        { label: "历史记录", id: 3, path: '/history' },
      ]
    };
  },
  computed: {
    getKey() {
      const { path, query } = this.$route
      return path + query.id
    },
    desList() {
      return this.list.filter(i => i.name.toLowerCase().indexOf(this.searchVal.toLowerCase()) != -1);
    },
  },
  // watch: {
  //   searchVal(val) {
  //     this.getSearch(val)
  //   }
  // },
  methods: {

    // getSearch(val) {
    //   this.privList = this.allList.filter(i => i.name.indexOf(val.toLowerCase()) !== -1)
    // },

    getActive(item) {
      const { query } = this.$route;
      if (item.id === query.id) {
        return 'activeList'
      }
      return ''
    },
    sendFormData(data) {
      console.log(data);
      this.submit(data)
    },

    submit(obj) {
      // console.log(this.tags);
      this.loading = true;
      axios.post(`/pmdm/admin/adminIntegrationApi/saveOrUpdate`, obj).then(res => {

        this.loading = false;
        this.$message.success(res.data.message);
      })

    },
    getItem(item) {
      this.$router.push({ path: '/settingAPI/info', query: item })
    },

    tabClick(e) {
      // let query = this.userInfo;
      // const query = {};
      const { path, query } = this.$route;
      this.$router.push({ path: '/settingAPI' + e.path, query });
    },

    async getData() {
      const { data } = await axios.get("/pmdm/admin/adminIntegrationApi/getAll");
      if (data.code == 200) {
        this.list = data.object.apiInfoList;
        const { path, query } = this.$route;
        if (!query?.id) {
          this.getItem(this.list[0])
        }

      }
    },

    closeAdd() {
      // this.$refs.addFormRef.clearValidate();
      this.applyTo = false;
      this.privsForm = {};
    },
    closeEdit() {
      // this.$refs.editFormRef.clearValidate();
      this.privsForm = {};
    },
    //添加
    addPriv() {
      this.dialogVisible = true;
      this.privDataList = {};
    },

    sendFormData(data) {
      console.log(data);
      this.submitForm(data)
    },
    async submitForm(obj) {
      axios.post(`/pmdm/admin/adminIntegrationApi/saveOrUpdate`, obj).then(res => {
        this.$message.success(res.data.message);
      })
    },

    //编辑
    editPriv(row) {
      axios.get("pmdm/admin/priv/getPriv?id=" + row.id)
        .then(res => {
          if (res.data.code == 200) {
            this.dialogVisible = true;
            this.privDataList = res.data.object;
          } else {
            return this.$message.error(res.data.message);
          }
        })
    },

    delItem(id) {
      axios
        .get("pmdm/admin/adminIntegrationApi/del?id=" + id)
        .then(res => {
          if (res.data.code == 200) {
            this.$message({
              type: "success",
              message: res.data.message,
            });
            this.getData();
          }
        })
        .catch(function (error) {
        });
    },
    async del(id) {
      this.$confirm(
        this.$t("message.confirm.deleteData"),
        this.$t("message.tips.tip"),
        {
          confirmButtonText: this.$t("message.button.affirm"),
          cancelButtonText: this.$t("message.button.cancel"),
          type: "warning",
        }
      )
        .then(() => {
          this.delItem(id);
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: this.$t("message.tips.deleteCancel"),
          });
        });
    },

  },
  created() {
    this.getData();
  },
};
</script>

<style scoped>
.role-content {
  display: flex;
  padding: 15px;
  gap: 10px;
}

.left-bar {
  width: 360px;
  flex-shrink: 0;
}

.search {
  display: flex;
  margin: 8px 5px;
  margin-right: 0;
  gap: 8px;
}

.list-content {
  /* padding: 0 15px; */
  height: calc(100vh - 240px);
  overflow-y: auto;
}

.route-content {
  flex: 1;
  padding: 0 15px;
  box-sizing: border-box;
}

.content-title {
  margin: 10px;
  padding: 10px 15px;
  border-bottom: 1px solid #EBEEF5;
  font-size: 14px;
  font-weight: 600;
}

.role-item {
  font-size: 12px;
  margin: 3px;
  cursor: pointer;
  padding: 3px 5px;
  border-radius: 3px;
  display: flex;
  align-items: center;
}

.role-label {
  width: 260px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.role-item:hover {
  /* color: #4b91ff; */
  background-color: #f5f7fa;
}

.activeList {
  background: #409EFF;
  color: #fff;
}

.activeList:hover {
  background: #409EFF;
}
</style>
